import { SearchBarErrorContainer, SearchBarErrorDescription, SearchBarErrorLabel } from './SearchAndSelectVehicle.style';
import { useSelector } from 'react-redux';
import { changeVehicleSelectors } from '../../store';

export enum ErrorType {
    NO_RESULTS_FOUND = 'NO_RESULTS_FOUND',
    NO_AGENT_RESULTS_FOUND = 'NO_AGENT_RESULTS_FOUND',
    CURRENT_VEHICLE = 'CURRENT_VEHICLE'
}
const SearchBarError = ({ errorType }: { errorType: ErrorType }) => {
    const isVehicleSearchRequested = useSelector(changeVehicleSelectors.getIsVehicleSearchRequested);

    if (!isVehicleSearchRequested) {
        return null;
    }

    const errorText = {
        [ErrorType.NO_RESULTS_FOUND]: {
            title: 'No results found',
            description:
                'Make sure you have specified the appropriate filters and correct VIN, Stock #, YMMT, or Inventory Type. You may modify the search query or Build the Vehicle above.'
        },
        [ErrorType.NO_AGENT_RESULTS_FOUND]: {
            title: 'No results found from AI-assisted search',
            description:
                "Check to ensure the prompt is accurate and try again. Try adjusting your search criteria by removing filters (click the 'X' in the search bar) or building the vehicle manually."
        },
        [ErrorType.CURRENT_VEHICLE]: {
            title: 'This is the current vehicle',
            description: 'Make sure you have entered another VIN or Stock #, not from your current vehicle'
        }
    };

    return (
        <SearchBarErrorContainer>
            <SearchBarErrorLabel>{errorText[errorType].title}</SearchBarErrorLabel>
            <SearchBarErrorDescription>{errorText[errorType].description}</SearchBarErrorDescription>
        </SearchBarErrorContainer>
    );
};

export default SearchBarError;
